import React, { Component } from "react";

import { get, put } from "../../api";
import { emit } from "../../events";

import Form from "../Form/Form";

import "./CMS.css";

class CMS extends Component {
  state = {
    firstPage: "",
    aboutUs: "",
    integrityPolicy: ""
  };

  componentDidMount() {
    this.fetchFirstPage();
    this.fetchAboutUs();
    this.fetchIntegrityPolicty();
  }

  fetchFirstPage = async () => {
    try {
      const { data: firstPage } = await get("/cms/first-page");
      this.setState({ firstPage });
    } catch (err) {
      alert(err.message);
    }
  };

  fetchAboutUs = async () => {
    try {
      const { data: aboutUs } = await get("/cms/about-us");
      this.setState({ aboutUs });
    } catch (err) {
      alert(err.message);
    }
  };

  fetchIntegrityPolicty = async () => {
    try {
      const { data: integrityPolicy } = await get("/cms/integrity-policy");
      this.setState({ integrityPolicy });
    } catch (err) {
      alert(err.message);
    }
  };

  saveFirstPage = async () => {
    const { firstPage = "" } = this.state;
    try {
      await put("/cms/first-page", {
        data: firstPage
      });
      emit("snackbar", "First page saved!");
    } catch (err) {
      alert(err.message);
    }
  };

  saveAboutUs = async () => {
    const { aboutUs = "" } = this.state;
    try {
      await put("/cms/about-us", {
        data: aboutUs
      });
      emit("snackbar", "About us saved!");
    } catch (err) {
      alert(err.message);
    }
  };

  saveIntegrityPolicy = async () => {
    const { integrityPolicy = "" } = this.state;
    try {
      await put("/cms/integrity-policy", {
        data: integrityPolicy
      });
      emit("snackbar", "Integrity policy saved!");
    } catch (err) {
      alert(err.message);
    }
  };

  render() {
    const { firstPage = "", aboutUs = "", integrityPolicy = "" } = this.state;

    return (
      <div className="CMS">
        <p>
          <a
            target="_blank"
            href="https://daringfireball.net/projects/markdown/basics"
          >
            Markdown
          </a>{" "}
          syntax supported.
        </p>
        <h2>First page</h2>
        <Form onSubmit={this.saveFirstPage}>
          <textarea
            spellCheck="false"
            value={firstPage}
            onChange={e => this.setState({ firstPage: e.target.value })}
          ></textarea>
          <div>
            <button>Save</button>
          </div>
        </Form>
        <h2>About us</h2>
        <Form onSubmit={this.saveAboutUs}>
          <textarea
            spellCheck="false"
            value={aboutUs}
            onChange={e => this.setState({ aboutUs: e.target.value })}
          ></textarea>
          <div>
            <button>Save</button>
          </div>
        </Form>
        <h2>Integrity policy</h2>
        <Form onSubmit={this.saveIntegrityPolicy}>
          <textarea
            spellCheck="false"
            value={integrityPolicy}
            onChange={e => this.setState({ integrityPolicy: e.target.value })}
          ></textarea>
          <div>
            <button>Save</button>
          </div>
        </Form>
      </div>
    );
  }
}

export default CMS;



// WEBPACK FOOTER //
// ./src/components/CMS/CMS.js